import {
	OverlayArrow,
	Popover as AriaPopover,
	type PopoverProps as AriaPopoverProps,
	composeRenderProps,
	PopoverContext,
	useSlottedContext
} from 'react-aria-components';
import React from 'react';
import { cn } from './utils';

export interface PopoverProps extends Omit<AriaPopoverProps, 'children'> {
	showArrow?: boolean;
	children: React.ReactNode;
}

export function Popover({ children, showArrow, className, ...props }: PopoverProps) {
	const popoverContext = useSlottedContext(PopoverContext)!;
	const isSubmenu = popoverContext?.trigger === 'SubmenuTrigger';
	let offset = showArrow ? 12 : 8;
	offset = isSubmenu ? offset - 6 : offset;
	return (
		<AriaPopover
			offset={offset}
			{...props}
			className={composeRenderProps(className, (className, renderProps) =>
				cn(
					'rounded-xl border border-black/10 bg-white bg-clip-padding text-slate-700 shadow-2xl forced-colors:bg-[Canvas]',
					renderProps.isEntering &&
						'animate-in fade-in placement-bottom:slide-in-from-top-1 placement-top:slide-in-from-bottom-1 placement-left:slide-in-from-right-1 placement-right:slide-in-from-left-1 duration-200 ease-out',
					renderProps.isExiting &&
						'animate-out fade-out placement-bottom:slide-out-to-top-1 placement-top:slide-out-to-bottom-1 placement-left:slide-out-to-right-1 placement-right:slide-out-to-left-1 duration-150 ease-in',
					className
				)
			)}
		>
			{showArrow && (
				<OverlayArrow className="group">
					<svg
						width={12}
						height={12}
						viewBox="0 0 12 12"
						className="block fill-white stroke-black/10 stroke-1 group-placement-left:-rotate-90 group-placement-right:rotate-90 group-placement-bottom:rotate-180 forced-colors:fill-[Canvas] forced-colors:stroke-[ButtonBorder]"
					>
						<path d="M0 0 L6 6 L12 0" />
					</svg>
				</OverlayArrow>
			)}
			{children}
		</AriaPopover>
	);
}
